import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            剧集索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            按类型快速找到你想看的电视剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 cursor-pointer no-underline block hover:border-primary-200 hover:bg-background-100 transition-all"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2">
                {item.description}
              </p>
              <span className="text-xs font-semibold text-primary-500">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}